import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

/**
 * Capture each .brochure__page child of `container` and assemble into a
 * multi-page A4 PDF. Returns the jsPDF instance after .save() runs.
 *
 * @param {HTMLElement} container — the rendered <Brochure> root
 * @param {string} filename — e.g. "skyline-residences-brochure.pdf"
 */
export const generateBrochurePDF = async (container, filename = 'brochure.pdf') => {
  if (!container) throw new Error('No brochure container provided');

  const pages = container.querySelectorAll('.brochure__page');
  if (pages.length === 0) throw new Error('No brochure pages found');

  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4',
    compress: true,
  });

  const a4Width = 210;
  const a4Height = 297;

  for (let i = 0; i < pages.length; i++) {
    const page = pages[i];

    // eslint-disable-next-line no-await-in-loop
    const canvas = await html2canvas(page, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      logging: false,
      imageTimeout: 15000,
    });

    const imgData = canvas.toDataURL('image/jpeg', 0.92);

    if (i > 0) pdf.addPage();
    pdf.addImage(imgData, 'JPEG', 0, 0, a4Width, a4Height, undefined, 'FAST');
  }

  pdf.save(filename);
  return pdf;
};

/**
 * Build a safe filename from a title.
 */
export const slugifyFilename = (name, suffix = 'brochure') => {
  const slug = (name || 'document')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 60);
  return `${slug}-${suffix}.pdf`;
};
